import { CatalogCartComponent } from './catalog_cart/catalog_cart.component'
import { ToCartComponent } from './to_cart/to_cart.component'
import { ItemPriceConditionsComponent } from './item_price_conditions/item_price_conditions.component'
import { ToCartThumbComponent } from './to_cart_thumb/to_cart_thumb.component'

import { CartThumbComponent } from './cart_thumb/cart_thumb.component'

import { MakeOrderComponent } from './make_order/make_order.component'

import { CartHeaderComponent } from './cart_header/cart_header.component'

let components = {
  CatalogCartComponent,
  ToCartComponent,
  ItemPriceConditionsComponent,
  ToCartThumbComponent,
  CartThumbComponent,
  MakeOrderComponent,
  CartHeaderComponent
}

export default components;



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/components.js